import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {UtilsService} from "../../../../shared/services/general/utils.service";
import {ReportService} from "../../../../shared/services/report/report.service";
import {structure} from "../../../../shared/model/structure";
import {ParamService} from "../../../../shared/services/param/param.service";
import {SecuService} from "../../../../shared/services/secu/secu.service";
import {utilisateur} from "../../../../shared/model/utilisateur";
import {LocalStorageService} from "../../../../shared/services/app/localstorage.service";
import {NgxSpinnerService} from "ngx-spinner";
import * as FileSaver from 'file-saver';
import {localisation} from "../../../../shared/model/localisation";
import { ActivatedRoute } from '@angular/router';
import {LibraryService} from "../../../../shared/services/app/library.service";

@Component({
  selector: 'app-conditions-utilisation',
  templateUrl: './conditions_utilisation.component.html',
  styleUrls: ['./conditions_utilisation.component.css']
})
export class ConditionsUtilisationComponent implements OnInit {

  constructor(private router: Router, private reportService: ReportService, private libraryService: LibraryService,
              private paramService: ParamService, private secuService: SecuService,
              private localStorage: LocalStorageService, private spinner: NgxSpinnerService,
              private toastr: ToastrService , private utils: UtilsService, private route: ActivatedRoute)
  {
  }

  public statsGen: any = {};
  departements: localisation[];   paramSearch: any;
  communes: localisation[]; structures: structure[];
  selectedDepartement: localisation;  selectedCommune: localisation;
  connUser: utilisateur;
  codeIndic: string;   private sub: any;

  experts: any[] = [];


  pageStartIndex : number = 0; limitTable: number[] = []; pageLimit: number = 0;

  trackByFn(): void {}



  ngOnInit() {


  }//end oninit

  ngOnDestroy() {
  }



  //date de debut
  getSelectedDateStart(event: Date){
    if(event !== undefined) event.setHours(new Date().getHours());
    this.paramSearch.startDate = event;
  }

  //date de fin
  getSelectedDateEnd(event: Date){
    if(event !== undefined) event.setHours(new Date().getHours());
    this.paramSearch.endDate = event;
  }

  //init reset form
  initForm(): void {
    this.selectedDepartement = null;  this.paramSearch.commune = null;
    this.paramSearch.structure = null;
    this.paramSearch.startDate = null; this.paramSearch.endDate = null;
  }//end initForm

  //has no references
  hasNoReferences(item: any){
    if(item.ressources_consultants === undefined) return true;
    if(item.ressources_consultants.length === 0) return true; else return false;
  }//end hasNoReferences


  //paginate on page change
  paginate(event: any): void{
    this.pageStartIndex = event.first;
    this.pageLimit = event.rows;
  }//fin

}
